import { WidgetSize, WidgetType } from 'components/farm-dashboard/types'
import { LicensesType } from 'models/IUserData'
export const MILKING_ROUTINE_TABLE_WIDGETS = [
	{
		id: WidgetType.MILKING_DEVIATIONS,
		type: WidgetType.MILKING_DEVIATIONS,
		size: WidgetSize.SMALL,
		license: LicensesType.MILKING_PROCESS,
	},
	{
		id: WidgetType.AVG_MILKING_TIME,
		type: WidgetType.AVG_MILKING_TIME,
		size: WidgetSize.SMALL,
		license: LicensesType.MILKING_PROCESS,
	},
	{
		id: WidgetType.AVG_CONNECT_TIME,
		type: WidgetType.AVG_CONNECT_TIME,
		size: WidgetSize.SMALL,
		license: LicensesType.MILKING_PROCESS,
	},
	{
		id: WidgetType.DEVIATIONS_CAROUSEL,
		type: WidgetType.DEVIATIONS_CAROUSEL,
		size: WidgetSize.SMALL,
		license: LicensesType.MILKING_PROCESS,
	},
	{
		id: WidgetType.DEVIATIONS_PARALLEL,
		type: WidgetType.DEVIATIONS_PARALLEL,
		size: WidgetSize.SMALL,
		license: LicensesType.MILKING_PROCESS,
	},
]
